class VideoProvider {
    constructor({ testRegex, urlRegex, urlText }) {
        this.matches = (url) => this._testRegex.test(url);
        this.convert = (url) => url.replace(this._urlRegex, this._urlText);
        this._testRegex = testRegex;
        this._urlRegex = urlRegex;
        this._urlText = urlText;
    }
}
// Inspired by froala
// ESlint is complaining but as this is copy-pasted code I'm not brave enough to fix it
/* eslint-disable no-useless-escape, no-irregular-whitespace */
const videoProviders = [
    new VideoProvider({
        testRegex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(shorts\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
        urlRegex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
        urlText: 'https://www.youtube.com/embed/$1?$2',
    }),
    new VideoProvider({
        testRegex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/​\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
        urlRegex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,
        urlText: 'https://player.vimeo.com/video/$1',
    }),
    new VideoProvider({
        testRegex: /^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,
        urlRegex: /(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,
        urlText: 'https://www.dailymotion.com/embed/video/$1',
    }),
    new VideoProvider({
        testRegex: /^.+(rutube.ru)\/[^_&]+/,
        urlRegex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,
        urlText: 'https://rutube.ru/play/embed/$1',
    }),
    new VideoProvider({
        testRegex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
        urlRegex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,
        urlText: 'https://play.vidyard.com/$1',
    }),
];
export class VideoLinkConverter {
}
VideoLinkConverter.isValid = (videoLink) => videoProviders.some((provider) => provider.matches(videoLink));
VideoLinkConverter.getEmbedCodeSrc = (videoLink) => {
    const maybeProvider = videoProviders.find((provider) => provider.matches(videoLink));
    if (maybeProvider === undefined) {
        return { success: false };
    }
    const embedCodeSrc = maybeProvider.convert(videoLink);
    return {
        success: true,
        embedCodeSrc,
    };
};
VideoLinkConverter.isYoutubeVideo = (videoLink) => {
    return /(?:youtube\.com|youtu\.be)/.test(videoLink);
};
